import { EpiPage } from '@api/types';
import { ContentArea, DataLoadingProgress } from '@components';
import { lazy, Suspense } from 'react';
const LazyCategoryBlock = lazy(() =>
  import('@components/blocks/category/CategoryBlock').then((m) => ({
    default: m.CategoryBlock,
  }))
);
export type CategoryPageContentProps = {
  page?: EpiPage;
};

export const CategoryPageContent = ({ page = {} }: CategoryPageContentProps) => {
  const { content } = page;
  return (
    <>
      <ContentArea content={content} enableNativeOverlay />
      <Suspense fallback={<DataLoadingProgress />}>
        <LazyCategoryBlock page={page} />
      </Suspense>
    </>
  );
};
